<style type="text/css">
    .loadercenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .overlay {
        position: fixed;
        display: block;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        /* background-color: black; */
        z-index: 99999;
        background-color: rgba(0, 0, 0, 0.219);
    }

    div.item {
        vertical-align: top;
        display: inline-block;
        text-align: center;
    }
</style>
<div class="overlay" [style.display]="isShowLoader ? 'block' : 'none'">
    <!-- <div class="loadercenter">
        <img src="{{assetURL}}/assets/images/GIF/loading.gif" width="64"
            height="64" alt="Loading...">
    </div> -->
    <div class="loader-modal loadercenter">
        <div class="loader"  #loaderRef></div>
    </div>
</div>
